import React, { ComponentProps, PureComponent, createRef } from 'react'
import { CloseIcon } from '@components/Icons'
import { Popup } from './Popup'
import {
  MiniPopupWrapper,
  Title,
  CustomContent,
  CloseIconWrapper
} from './MiniPopup.elements'

type Props = ComponentProps<typeof Popup> & {
  title?: string
}

export class MiniPopup extends PureComponent<Props> {
  popupRef = createRef<Popup>()

  public close = () => {
    const { current } = this.popupRef
    current && current.close()
  }

  render() {
    const { title, children, ...props } = this.props

    return (
      <Popup
        {...props}
        closeIcon={(
          <CloseIconWrapper>
            <CloseIcon />
          </CloseIconWrapper>
        )}
        ref={this.popupRef}
      >
        <MiniPopupWrapper>
          {title && (<Title>{title}</Title>)}
          <CustomContent>{children}</CustomContent>
        </MiniPopupWrapper>
      </Popup>
    )
  }
}
